// External libraries
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';

// Internal imports - state
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';

// Internal imports - components
import { TextComponentWrapper } from '@sharedComponents/text/TextComponent';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

// Styles
import styles from './TextPage.module.scss';

/**
 * Represents the page for managing Text entities.
 * Provides navigation breadcrumbs and renders the main text management component.
 *
 * @component
 * @category Pages
 * @group Text Management
 */
export function TextPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId) ?? '';

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.texts.page') }]} />
      <Paper className={styles.container}>
        <TextComponentWrapper organizationId={organizationId} store={store} />
      </Paper>
    </>
  );
}
